import { IconFn, IconSvg } from "../createIcon";

export const LogoIcon: IconFn = ({ ...props }) => (
  <IconSvg
    fill="none"
    viewBox={{
      minX: 0,
      minY: 0,
      width: 200,
      height: 200,
    }}
    {...props}
  >
    <g clipPath="url(#a)">
      <g filter="url(#b)">
        <path d="M200 0H0v200h200V0Z" fill="#655C94" />
        <path d="M58.594 44.895h21.91v110.209h-21.91V44.895Z" fill="#E7D54F" />
        <path
          d="M127.993 53.691c-6.175-6.328-14.666-8.796-30.72-8.796H83.623l-.02 18.833h13.824c2.083 0 3.927.166 5.539.51.537.114 1.048.253 1.539.405.975.312 1.858.71 2.64 1.201a9.663 9.663 0 0 1 1.619 1.254c.325.312.63.65.909 1.015.424.544.796 1.14 1.127 1.797.438.876.796 1.851 1.082 2.94.424 1.624.676 3.502.776 5.638.033.71.046 1.452.046 2.228 0 12.345-4.166 16.976-15.283 16.976H83.555l-.02 18.985h13.739c14.819 0 22.998-2.163 29.174-7.563 6.952-6.023 9.877-14.507 9.877-28.404 0-12.969-2.468-20.836-8.332-27.012v-.007Z"
          fill="#BCCCDD"
        />
        <path
          d="M121.121 116.1c-5.506 2.48-12.57 3.555-22.647 3.608l16.703 35.396h26.243L121.128 116.1h-.007Z"
          fill="#fff"
        />
      </g>
      <path d="M200 0H0v200h200V0Z" fill="#655C91" />
      <path d="M58.6 44.9h21.9v110.22H58.6V44.9Z" fill="#E4D24F" />
      <path
        d="M136.464 90.16c.2-1.42.34-2.92.42-4.48.1-1.58.14-3.22.14-4.96 0-12.96-2.46-20.84-8.34-27.02a24.5 24.5 0 0 0-5.14-4.04c-5.74-3.36-13.54-4.76-25.58-4.76h-13.66v18.84h13.8c8.34 0 12.76 2.6 14.46 9.12.56 2.18.82 4.78.82 7.86 0 7.72-1.62 12.42-5.56 14.86-2.36 1.46-5.56 2.12-9.72 2.12h-13.86v18.98h13.72c14.82 0 23-2.16 29.18-7.56 3.48-3.02 5.94-6.64 7.54-11.24.8-2.3 1.38-4.86 1.76-7.7l.02-.02Z"
        fill="#BCCCDD"
      />
      <path d="M121.519 116.898c-5.66 2.38-12.82 3.42-22.74 3.48l16.38 34.74h26.24l-19.88-38.22Z" fill="#fff" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h200v200H0z" />
      </clipPath>
      <filter
        id="b"
        x={0}
        y={0}
        width={224.32}
        height={224.32}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx={12.16} dy={12.16} />
        <feGaussianBlur stdDeviation={6.08} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_937_3264" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_937_3264" result="shape" />
      </filter>
    </defs>
  </IconSvg>
);
